import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import ProjectionField from 'modules/reports/components/Editor/Carcasa/FormFields/ProjectionField'
import { FieldSelectionType } from 'modules/reports/hooks/useReportTracking'
import { ABILITIES, TYPES } from 'modules/reports/lib/Constants'
import type { ReportEditorStore } from 'modules/reports/lib/Store'

interface Props {
  store: ReportEditorStore
}

const PieFormView = (props: Props) => {
  const { store } = props

  const labelFormIndex0 = {
    text: i18n.t('custom_reports.fields.pie.initial_data.title'),
    tooltipText: i18n.tView('custom_reports.fields.pie.initial_data.tooltip', {
      unit1: <b>{i18n.t('custom_reports.fields.number')}</b>,
    }),
  }

  const labelFormIndex1 = {
    text: i18n.t('custom_reports.fields.pie.group_by.title'),
    tooltipText: i18n.tView('custom_reports.fields.pie.group_by.tooltip', {
      unit1: <b>{i18n.t('custom_reports.fields.text')}</b>,
      unit2: <b>{i18n.t('custom_reports.fields.date')}</b>,
    }),
  }

  return (
    <>
      <ProjectionField
        selectionType={FieldSelectionType.Data}
        store={store}
        formIndex={0}
        fieldAbilityTypes={[ABILITIES.aggregation, ABILITIES.ordering]}
        buttonLabel={i18n.t('custom_reports.fields.pie.group_by.button')}
        label={labelFormIndex0}
        excludeTypes={[
          TYPES.cohort,
          TYPES.text,
          TYPES.date,
          TYPES.enum,
          TYPES.link,
          TYPES.unit,
          TYPES.boolean,
        ]}
      />
      <ProjectionField
        selectionType={FieldSelectionType.BreakdownBy}
        store={store}
        fieldAbilityTypes={[ABILITIES.grouping, ABILITIES.ordering]}
        formIndex={1}
        buttonLabel={i18n.t('custom_reports.fields.pie.group_by.button')}
        label={labelFormIndex1}
        excludeIdentifiers
        excludeTypes={[TYPES.link]}
      />
    </>
  )
}

export default PieFormView
